// Function to dynamically load the JavaScript file from a specific URL
function loadScriptAsync(url) {
  var script = document.createElement("script");
  script.type = "text/javascript";
  script.src = url;
  script.async = true; // Load the script asynchronously

  // Append the script to the head of the document
  document.head.appendChild(script);
}

// This function sets up the click event listener on the input field
function setupScriptLoadOnClick(inputSelector, scriptUrl) {
  var inputField = document.querySelector(inputSelector);
  if (!inputField) return; // Exit if the input field doesn't exist

  // Add a click event listener to the input field
  inputField.addEventListener("click", function () {
    // Load the script asynchronously when the input field is clicked
    loadScriptAsync(scriptUrl);

    // Optionally, remove the event listener if the script only needs to be loaded once
    inputField.removeEventListener("click", arguments.callee);
  });
}

// URL of the external JavaScript file you want to include
var externalJsUrl =
  "https://static.mailerlite.com/js/w/webforms.min.js?v87f6253ef300d8389c2a107d688de385";

// Setup the script to load when the input field is clicked
setupScriptLoadOnClick("#mailerliteEmail", externalJsUrl);
